import * as yup from 'yup';

export const personalDetailSchema = yup.object().shape({
  citizenship: yup.string().notRequired(),
  visaSubClass: yup.string().notRequired(),
  visaExpiryDate: yup.string().notRequired(),
  country: yup.string().notRequired(),
  permanentResident: yup.boolean().notRequired(),
  currentResidentalStatus: yup.string().notRequired(),
  residentalOtherSpecification: yup.string().notRequired(),
  maritalStatus: yup.string().notRequired(),
  dependentChildren: yup.boolean().notRequired(),
  numberOfDependents: yup.number().notRequired(),
  rentExpense: yup.number().notRequired(),
  frequencyOfRent: yup.string().notRequired(),
  isTheResidentialPlaceMortgaged: yup.boolean().notRequired(),
  taxResidencyStatus: yup.string().notRequired(),
});

export const personalDetailLabelMapper = {
  citizenship: 'What’s your citizenship?',
  country: 'Which country do you currently reside in?',
  permanentResident: 'Are you a Permanent Resident(PR) of this country?',
  currentResidentalStatus: 'What’s your current residential status?',
  maritalStatus: 'What is your marital status?',
  dependentChildren: 'Do you have any dependent children?',
};
